module.exports = __webpack_public_path__ + "img/Julius.1bf27356.jpg";